// Browsers only allow autoplay-with-sound after real user interaction, so
// the hero video starts muted (see the `media` shortcode) and this just
// unmutes it on the visitor's first interaction — toggling `.muted` on
// already-playing media isn't subject to that restriction the way
// *starting* playback with sound is.
const videos = document.querySelectorAll("video[data-sound]");
if (videos.length) {
  const events = ["pointerdown", "keydown", "touchstart"];
  const unmute = () => {
    videos.forEach((video) => {
      video.muted = false;
      if (video.paused) video.play().catch(() => {});
    });
    events.forEach((type) => document.removeEventListener(type, unmute));
  };
  events.forEach((type) => document.addEventListener(type, unmute));
}
